import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Layout from './components/Layout/Layout'
import Login from './components/Auth/Login'
import Dashboard from './components/Dashboard/Dashboard'
import ProjectList from './components/Dashboard/ProjectList'
import UploadView from './components/Upload/UploadView'
import MapViewer from './components/Map/MapViewer'
import ClientManager from './components/Admin/ClientManager'
import AuditLog from './components/Admin/AuditLog'
import UserManager from './components/Admin/UserManager'
import { getMe } from './services/api'
import { User } from './types'

function App() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('dronemap_token')
    if (token) {
      getMe()
        .then(res => setUser(res.data.user))
        .catch(() => {
          localStorage.removeItem('dronemap_token')
          localStorage.removeItem('dronemap_user')
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    )
  }

  if (!user) {
    return <Login onLogin={(u) => setUser(u)} />
  }

  const isAdmin = user.role === 'superadmin' || user.role === 'admin'
  const isStaff = user.role === 'staff'

  return (
    <Layout user={user} onLogout={() => {
      localStorage.removeItem('dronemap_token')
      localStorage.removeItem('dronemap_user')
      setUser(null)
    }}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<ProjectList />} />
        <Route path="/projects/:projectId" element={<ProjectList />} />
        <Route path="/upload/:uploadId" element={<UploadView />} />
        <Route path="/map/:uploadId" element={<MapViewer />} />
        {(isAdmin || isStaff) && (
          <>
            <Route path="/admin/clients" element={<ClientManager />} />
            <Route path="/admin/audit" element={<AuditLog />} />
            <Route path="/admin/users" element={<UserManager />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
